module.exports = __webpack_public_path__ + "static/media/video6.59a37fe.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video6.mp4
// module id = zFpW
// module chunks = 1